import { render } from "./CreateCollaboratorsFileModal.vue?vue&type=template&id=6f1b4b94"
import script from "./CreateCollaboratorsFileModal.vue?vue&type=script&lang=js"
export * from "./CreateCollaboratorsFileModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__